import { ModelDataMetro } from 'src/components/Search/Common/Metro/types';
import fetcher from 'src/utils/fetcher';

const GET_METRO_URL = '/shards/get_area_metro';

declare global {
    interface FetcherGetApi {
        [GET_METRO_URL]: {
            queryParams: {
                area: string;
            };
            response: {
                result: ModelDataMetro[];
            };
        };
    }
}

type UseGetAreaMetro = (area: string, signal?: AbortSignal) => Promise<{ result: ModelDataMetro[] }>;

const getAreaMetro: UseGetAreaMetro = (area, signal) => {
    return fetcher.get(GET_METRO_URL, { params: { area }, signal }).catch((e) => {
        if (!fetcher.isCancel(e)) {
            console.error(e);
        }

        throw e;
    });
};

export default getAreaMetro;
